import React from 'react';
import '../App.css';

function MainStructure() {
  return (
    <div className="box">
      <div className="container mt-3">
        <div className="row g-3">
          <div className="d-flex flex-column justify-content-center">
            <h1 className="text-center">Welcome to My Portfolio</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainStructure;
